module.exports = __webpack_public_path__ + "static/img/but.4f7968f2.png";